{
  "common.close": "Κλείσιμο",
  "common.athleteFallback": "αθλητής {id}",
  "splash.title": "{app} — Κινούμενη απεικόνιση δραστηριοτήτων",
  "splash.tagline": "Τα δεδομένα σας από τη Strava σε&nbsp;κίνηση",
  "splash.demo": "Επίδειξη",
  "tab.query.title": "Χάρτης: {name}",
  "tab.query.heading": "Αναζήτηση δραστηριοτήτων:",
  "tab.query.optDays": "τελευταίες ημέρες",
  "tab.query.optActivities": "τελευταίες δραστηριότητες",
  "tab.query.optIds": "Αναγνωριστικά δραστηριοτήτων",
  "tab.query.optDates": "Εύρος ημερομηνιών",
  "tab.query.idsPlaceholder": "εισαγάγετε εδώ αναγνωριστικά δραστηριοτήτων",
  "tab.query.after": "Από:",
  "tab.query.before": "Έως:",
  "tab.query.autozoom": "Αυτόματη εστίαση <i class=\"hf hf-bullseye\"></i> στα αποτελέσματα μετά την εισαγωγή",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Φόρτωση",
  "tab.query.createAccount": "Δημιουργήστε λογαριασμό ή/και συνδεθείτε.",
  "tab.query.sports": "Αθλήματα:",
  "tab.query.allSports": "Όλα τα αθλήματα",
  "tab.query.sportsExcept": "Όλα εκτός από",
  "tab.query.sportsNone": "Κανένα",
  "tab.query.loadingSports": "Φόρτωση αθλημάτων…",
  "tab.query.sportsFailed": "Δεν ήταν δυνατή η φόρτωση των αθλημάτων αυτού του χάρτη",
  "tab.query.noSports": "Δεν υπάρχουν ακόμη δραστηριότητες",
  "tab.activities.title": "Εμφανιζόμενες δραστηριότητες",
  "tab.activities.clearSelection": "Απαλοιφή επιλογής",
  "tab.activities.renderSelected": "Εμφάνιση επιλεγμένων",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Εστίαση στην επιλογή",
  "tab.controls.title": "Ρυθμίσεις επιπέδου",
  "tab.controls.timescale": "Χρονική κλίμακα <i>&tau;</i>",
  "tab.controls.timescaleHint": "ταχύτητα αναπαραγωγής",
  "tab.controls.period": "Περίοδος <i>T</i>",
  "tab.controls.periodHint": "δραστηριότητα ~ μοντέλο",
  "tab.controls.dotSize": "Μέγεθος κουκκίδων",
  "tab.controls.pathWidth": "Πάχος διαδρομών",
  "tab.controls.pathWidthHint": "το μηδέν κρύβει τις διαδρομές",
  "tab.controls.colors": "Χρώματα",
  "tab.controls.colorsHint": "περιστροφή παλέτας",
  "tab.controls.shadows": "Σκιές",
  "tab.profile.loginTitle": "Σύνδεση",
  "tab.profile.anonNote": "Συνδεθείτε με τη Strava για να δείτε τις δικές σας δραστηριότητες και να διαχειριστείτε τον λογαριασμό σας στο Heatflask.",
  "tab.profile.loginLink": "Σύνδεση με τη Strava",
  "tab.profile.editOnStrava": "Επεξεργασία προφίλ στη Strava",
  "tab.profile.indexNote": "Ευρετηριάζουμε τις συνόψεις των δραστηριοτήτων σας για γρήγορη πρόσβαση.",
  "tab.profile.viewIndex": "Προβολή ευρετηρίου",
  "tab.profile.sharedMaps": "Κοινόχρηστοι χάρτες",
  "tab.profile.sharedMapsNote": "Ανενεργό: μόνο εσείς βλέπετε τις δραστηριότητές σας στο Heatflask. Ενεργό: όποιος έχει σύνδεσμο προς τον χάρτη σας βλέπει τις δραστηριότητες που έχετε κάνει δημόσιες στη Strava. Οι ιδιωτικές παραμένουν δικές σας σε κάθε περίπτωση. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Πώς λειτουργεί το απόρρητο</a>",
  "tab.profile.logout": "Αποσύνδεση",
  "tab.profile.deleteAccount": "Διαγραφή λογαριασμού",
  "tab.profile.deleteConfirm": "Διαγραφή του λογαριασμού σας στο Heatflask;\n\nΑυτό αφαιρεί τις ευρετηριασμένες δραστηριότητές σας και ανακαλεί την πρόσβαση του Heatflask στα δεδομένα σας στη Strava. Δεν είναι δυνατή η αναίρεση.",
  "tab.profile.languageHeading": "Γλώσσα",
  "tab.profile.languageAuto": "Αυτόματα",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Βοηθήστε μας να διορθώσουμε ή να προσθέσουμε μεταφράσεις!</a>",
  "tab.profile.unitsHeading": "Μονάδες",
  "tab.profile.unitsAuto": "Αυτόματα",
  "tab.profile.unitsMetric": "Μετρικό (km, m)",
  "tab.profile.unitsImperial": "Αγγλοσαξονικό (mi, ft)",
  "tab.profile.textSizeHeading": "Μέγεθος κειμένου",
  "tab.profile.textSmaller": "Μικρότερο",
  "tab.profile.textReset": "Κανονικό",
  "tab.profile.textLarger": "Μεγαλύτερο",
  "tab.profile.mapDefaultsHeading": "Προεπιλογές χάρτη",
  "tab.profile.mapDefaultsNote": "Αυτός ο χάρτης βάσης, το ανάγλυφο και οι ρυθμίσεις επιπέδου χρησιμοποιούνται κάθε φορά που ανοίγετε έναν χάρτη του οποίου ο σύνδεσμος δεν ορίζει δικές του. Οι σύνδεσμοι που μοιράζεστε εξακολουθούν να δείχνουν ακριβώς ό,τι βλέπετε.",
  "tab.profile.mapDefaultsSave": "Αποθήκευση ως προεπιλογές μου",
  "tab.profile.mapDefaultsForget": "Διαγραφή",
  "tab.info.title": "Πληροφορίες",
  "tab.info.controlsHeading": "Χειρισμός",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + σύρσιμο",
  "tab.info.shiftDragDesc": "Επιλογή δραστηριοτήτων μέσα σε ένα πλαίσιο. Σε οθόνη αφής, πατήστε πρώτα το <i class=\"hf-object-group\"></i> και μετά σύρετε με ένα δάχτυλο. Η τελευταία επιλεγμένη δραστηριότητα δείχνει τις λεπτομέρειές της και η λίστα δραστηριοτήτων κυλά μέχρι αυτήν.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + σύρσιμο",
  "tab.info.ctrlDragDesc": "Περιστροφή και κλίση του χάρτη σε 3D, ή με δύο δάχτυλα",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Άνοιγμα ή κλείσιμο της πλαϊνής στήλης",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Προηγούμενη ή επόμενη καρτέλα",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Κλείσιμο της πλαϊνής στήλης",
  "tab.info.liveUrlHeading": "Ζωντανό URL",
  "tab.info.liveUrlDesc": "Η προβολή του χάρτη και οι ρυθμίσεις της κίνησης αποθηκεύονται στο URL της σελίδας, ώστε όποιος το λάβει από εσάς να βλέπει την ίδια προβολή.",
  "tab.info.videoHeading": "Εξαγωγή βίντεο",
  "tab.info.videoDesc": "Το κουμπί <i class=\"hf-video-camera\"></i> καταγράφει την κίνηση ως MP4: πατήστε το, προσαρμόστε το πλαίσιο πάνω στο τμήμα του χάρτη που θέλετε και πατήστε ξανά για εγγραφή. Καταγράφεται ένας πλήρης κύκλος της κίνησης, ώστε το βίντεο να επαναλαμβάνεται χωρίς διακοπή· ένας κύκλος μεγαλύτερος από {max} δευτερόλεπτα (το μεγαλύτερο βίντεο που δέχεται η Strava) κόβεται στα {max}.",
  "tab.info.contributeHeading": "Συνεισφορά",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Χορηγία στο GitHub",
  "tab.info.contactsHeading": "Επικοινωνία",
  "map.basemapAndTerrain": "Χάρτης βάσης και ανάγλυφο",
  "map.pauseAnimation": "Παύση κίνησης",
  "map.resumeAnimation": "Συνέχιση κίνησης",
  "capture.record": "Εγγραφή βίντεο (κύκλος {period} δ.)",
  "capture.recordTruncated": "Εγγραφή βίντεο (ένας κύκλος διαρκεί {period} δ.· θα εγγραφούν μόνο τα πρώτα {max} δ.)",
  "capture.recordArea": "Εγγραφή της περιοχής μέσα στο πλαίσιο",
  "capture.stop": "Διακοπή εγγραφής",
  "capture.selectionTooSmall": "η επιλογή είναι πολύ μικρή",
  "capture.saved": "αποθηκεύτηκε: {name} ({size})",
  "capture.cancelled": "η εγγραφή ακυρώθηκε",
  "capture.failed": "η εγγραφή απέτυχε: {error}",
  "capture.loadingEncoder": "φόρτωση κωδικοποιητή…",
  "capture.waitingForMap": "αναμονή για φόρτωση του χάρτη…",
  "capture.encoding": "κωδικοποίηση… {percent}%",
  "capture.finalizing": "ολοκλήρωση…",
  "share.title": "Κοινοποίηση συνδέσμου προς αυτόν τον χάρτη",
  "share.copied": "ο σύνδεσμος αντιγράφηκε",
  "share.copiedUnshared": "ο σύνδεσμος αντιγράφηκε — όμως ο χάρτης σας δεν είναι κοινόχρηστος, οπότε κανείς άλλος δεν μπορεί να τον ανοίξει. Ενεργοποιήστε τους «Κοινόχρηστους χάρτες» για να το αλλάξετε.",
  "share.unshared": "Ο χάρτης σας δεν είναι κοινόχρηστος, οπότε κανείς άλλος δεν μπορεί να ανοίξει αυτόν τον σύνδεσμο. Ενεργοποιήστε τους «Κοινόχρηστους χάρτες» για να το αλλάξετε.",
  "share.copyThis": "Αντιγράψτε αυτόν τον σύνδεσμο:",
  "update.available": "Υπάρχει διαθέσιμη νέα έκδοση του Heatflask.",
  "update.reload": "Επαναφόρτωση",
  "import.title": "Εισαγωγή",
  "import.stop": "Διακοπή",
  "import.stopping": "διακοπή…",
  "import.contacting": "σύνδεση με τη Strava…",
  "import.countOf": "Δραστηριότητες: {received} από {total}",
  "import.count": "Δραστηριότητες: {received}",
  "import.waitStrava": "Σε παύση λόγω του ορίου λήψεων της Strava έως τις {time}. Αφήστε τη σελίδα ανοιχτή· η επαναφόρτωση δεν θα το επιταχύνει.",
  "import.waitRationed": "Οι γρήγορες λήψεις της ημέρας εξαντλήθηκαν. Οι υπόλοιπες συνεχίζουν στις {time}, πιο αργά. Αφήστε τη σελίδα ανοιχτή.",
  "import.dailyLimit": "Το ημερήσιο όριο λήψεων της Strava εξαντλήθηκε. Δοκιμάστε ξανά μετά τις {time}.",
  "import.dailyRationed": "Το σημερινό σας μερίδιο λήψεων από τη Strava εξαντλήθηκε. Δοκιμάστε ξανά μετά τις {time}.",
  "import.noActivitiesYet": "Ο λογαριασμός σας στη Strava δεν έχει ακόμη δραστηριότητες. Καταγράψτε ή ανεβάστε μία στη Strava και θα εμφανιστεί εδώ.",
  "table.noActivities": "καμία δραστηριότητα",
  "table.untitled": "(χωρίς τίτλο)",
  "activities.pageTitle": "{app} — Ευρετήριο δραστηριοτήτων",
  "activities.heading": "Ευρετήριο δραστηριοτήτων",
  "activities.fetching": "Λήψη δραστηριοτήτων...",
  "activities.rateLimit": "Συμπληρώθηκε το όριο αιτημάτων της Strava· συνέχεια στις {time}",
  "activities.noData": "Δυστυχώς δεν υπάρχουν δεδομένα &#128577;",
  "activities.colServerCache": "Η διαδρομή είναι αποθηκευμένη στον διακομιστή (Mongo)",
  "activities.colBrowserCache": "Η διαδρομή είναι αποθηκευμένη σε αυτό το πρόγραμμα περιήγησης",
  "activities.cachedServer": "Η διαδρομή της δραστηριότητας {id} είναι αποθηκευμένη στον διακομιστή",
  "activities.notCachedServer": "Η διαδρομή της δραστηριότητας {id} δεν είναι αποθηκευμένη στον διακομιστή",
  "activities.cachedBrowser": "Η διαδρομή της δραστηριότητας {id} είναι αποθηκευμένη σε αυτό το πρόγραμμα περιήγησης",
  "activities.notCachedBrowser": "Η διαδρομή της δραστηριότητας {id} δεν είναι αποθηκευμένη σε αυτό το πρόγραμμα περιήγησης",
  "sport.AlpineSki": "Αλπικό σκι",
  "sport.BackcountrySki": "Ορειβατικό σκι",
  "sport.Badminton": "Μπάντμιντον",
  "sport.Basketball": "Μπάσκετ",
  "sport.Canoeing": "Κανό",
  "sport.Cricket": "Κρίκετ",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Χορός",
  "sport.EBikeRide": "Ηλεκτρικό ποδήλατο",
  "sport.Elliptical": "Ελλειπτικό",
  "sport.EMountainBikeRide": "Ηλεκτρικό ορεινό ποδήλατο",
  "sport.Golf": "Γκολφ",
  "sport.GravelRide": "Ποδήλατο gravel",
  "sport.Handcycle": "Χειροποδήλατο",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Πεζοπορία",
  "sport.IceSkate": "Πατινάζ στον πάγο",
  "sport.InlineSkate": "Πατίνια",
  "sport.Kayaking": "Καγιάκ",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Ορεινή ποδηλασία",
  "sport.NordicSki": "Σκι αντοχής",
  "sport.Padel": "Πάντελ",
  "sport.PhysicalTherapy": "Φυσικοθεραπεία",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Ποδηλασία",
  "sport.RockClimbing": "Αναρρίχηση",
  "sport.RollerSki": "Σκι με ρόδες",
  "sport.Rowing": "Κωπηλασία",
  "sport.Run": "Τρέξιμο",
  "sport.Sail": "Ιστιοπλοΐα",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Χιονοπέδιλα",
  "sport.Soccer": "Ποδόσφαιρο",
  "sport.Squash": "Σκουός",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "SUP",
  "sport.Surfing": "Σέρφινγκ",
  "sport.Swim": "Κολύμβηση",
  "sport.TableTennis": "Πινγκ πονγκ",
  "sport.Tennis": "Τένις",
  "sport.TrailRun": "Ορεινό τρέξιμο",
  "sport.Velomobile": "Βελομομπίλ",
  "sport.VirtualRide": "Εικονική ποδηλασία",
  "sport.VirtualRow": "Εικονική κωπηλασία",
  "sport.VirtualRun": "Εικονικό τρέξιμο",
  "sport.Volleyball": "Βόλεϊ",
  "sport.Walk": "Περπάτημα",
  "sport.WeightTraining": "Προπόνηση με βάρη",
  "sport.Wheelchair": "Αναπηρικό αμαξίδιο",
  "sport.Windsurf": "Ιστιοσανίδα",
  "sport.Workout": "Προπόνηση",
  "sport.Yoga": "Γιόγκα"
}
